import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { ModalDivider } from "@/components/UI2/molecules/Modal";

import { FORM_ID } from "./constants";

export type AcceptedAgeRangeFormActionsProps = {
  isDisabled: boolean;
  onCancel: () => void;
};

export function AcceptedAgeRangeFormActions({
  isDisabled,
  onCancel,
}: AcceptedAgeRangeFormActionsProps) {
  return (
    <>
      <ModalDivider />

      <div className="tw:flex tw:justify-end tw:gap-3">
        <Button2 onPress={onCancel} type="button" variant="secondary">
          Cancel
        </Button2>
        <Button2
          form={FORM_ID}
          isDisabled={isDisabled}
          type="submit"
          variant="primary"
          {...getAutomationDataAttr("AcceptedAgeRangeSaveButton")}
        >
          Save
        </Button2>
      </div>
    </>
  );
}
